var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaqinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 427,
    viewBox: "0 0 427 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.646 329.098l-22.5 11-24.5-29.5 11-108 24.5-8.5 19.5 19c-28.4 45.2-17.167 96.166-8 116z",
    fill: "#FF8484",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.044 139.967c-.51 12.329 3.46 21.172 10.292 25.501l102.457 64.931 58.595-92.459-102.457-64.93c-6.831-4.33-16.522-4.145-27.454 1.579-16.902 8.849-31.823 28.348-38.196 48.135-1.872 5.81-3.006 11.645-3.237 17.243z",
    fill: "#FF8484",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.646 219.598c6.4-19.6 6.666-38.167 6.5-45l41 25.5-1.5 2.5c-27.2 56.8-16.667 115.666-8 138-18.5-5.5-34-18.5-43-33s-3-63.5 5-88z",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.141 220.098c6.4-19.6 6.666-38.167 6.5-45l41 25.5-1.5 2.5c-27.2 56.8-16.667 115.666-8 138-18.5-5.5-34-18.5-43-33s-3-63.5 5-88z",
    fill: "#FFB5B5",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.477 120.589c-16.902 8.849-31.823 28.348-38.196 48.135-1.872 5.81-3.006 11.645-3.237 17.243-.509 12.329 3.461 21.172 10.292 25.501l85.809 128.626-7.5-45.496 11-54 35.5-57 40-31.5 47.001-14.001-153.215-19.088c-6.831-4.329-16.522-4.144-27.454 1.58z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.737 346.469c-48.67 25.483-86.288 1.642-84.022-53.249 2.267-54.891 43.559-120.047 92.23-145.529 48.67-25.483 86.288-1.643 84.021 53.248-2.266 54.891-43.559 120.047-92.229 145.53z",
    fill: "#FF8484",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288.21 335.001c-43.054 22.542-76.331 1.453-74.326-47.104 2.005-48.557 38.532-106.194 81.586-128.736 43.054-22.543 76.331-1.453 74.326 47.104-2.005 48.556-38.532 106.194-81.586 128.736z",
    fill: "#FFB5B5",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.646 248.729l70.544 28.537 31.004-55.999-55.632-42.169c-19.961 18.521-36.541 43.742-45.916 69.631z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M222.646 248.729l-2.351-.851a2.5 2.5 0 001.413 3.169l.938-2.318zm70.544 28.537l-.937 2.318a2.499 2.499 0 003.124-1.107l-2.187-1.211zm31.004-55.999l2.188 1.211a2.5 2.5 0 00-.677-3.203l-1.511 1.992zm-55.632-42.169l1.51-1.993a2.5 2.5 0 00-3.21.16l1.7 1.833zm-46.854 71.949l70.545 28.537 1.875-4.635-70.545-28.537-1.875 4.635zm73.669 27.43l31.005-55.999-4.375-2.421-31.004 55.998 4.374 2.422zm30.328-59.202l-55.633-42.17-3.02 3.985 55.632 42.17 3.021-3.985zm-58.843-42.01c-20.259 18.798-37.059 44.357-46.567 70.613l4.701 1.703c9.244-25.524 25.604-50.406 45.267-68.651l-3.401-3.665z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M307.026 275.646c-12.856 6.732-22.793.434-22.194-14.065.599-14.499 11.506-31.71 24.362-38.441 12.856-6.732 22.793-.434 22.194 14.065-.599 14.5-11.506 31.71-24.362 38.441z",
    fill: "#FF8484",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgFaqinline;